export default __webpack_public_path__ + "static/media/how-it-works-3.15e9ee09.svg";